/** A vertical mouse wheel cannot move a horizontal-only strip, so use its dominant axis. */
export function scrollTabStripFromWheel(strip, event) {
  if (!strip || strip.scrollWidth <= strip.clientWidth) return false;

  const deltaX = Number(event?.deltaX) || 0;
  const deltaY = Number(event?.deltaY) || 0;
  const delta = Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY;
  if (!delta) return false;

  const maxScrollLeft = Math.max(0, strip.scrollWidth - strip.clientWidth);
  const nextScrollLeft = Math.min(maxScrollLeft, Math.max(0, strip.scrollLeft + delta));
  if (nextScrollLeft === strip.scrollLeft) return false;

  strip.scrollLeft = nextScrollLeft;
  return true;
}

/** Focus can land on a clipped tab before the browser reveals it; keep a small edge inset. */
export function revealTabInStrip(strip, tab) {
  if (!strip || !tab) return false;

  const revealInset = 8;
  const stripRect = strip.getBoundingClientRect();
  const tabRect = tab.getBoundingClientRect();
  const viewportStart = strip.scrollLeft;
  const viewportEnd = viewportStart + strip.clientWidth;
  // offsetLeft belongs to the tab's offset parent, which may start before the scroll strip.
  const tabStart = viewportStart + tabRect.left - stripRect.left;
  const tabEnd = viewportStart + tabRect.right - stripRect.left;
  let nextScrollLeft = viewportStart;

  if (tabStart < viewportStart + revealInset) nextScrollLeft = tabStart - revealInset;
  else if (tabEnd > viewportEnd - revealInset) nextScrollLeft = tabEnd - strip.clientWidth + revealInset;
  else return false;

  const maxScrollLeft = Math.max(0, strip.scrollWidth - strip.clientWidth);
  strip.scrollLeft = Math.min(maxScrollLeft, Math.max(0, nextScrollLeft));
  return true;
}
